import { render, staticRenderFns } from "./SeminarTrailer.vue?vue&type=template&id=38bc8aff&scoped=true&"
import script from "./SeminarTrailer.vue?vue&type=script&lang=js&"
export * from "./SeminarTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc8aff",
  null
  
)

export default component.exports